import { render, staticRenderFns } from "./cModalProducts.vue?vue&type=template&id=2c9a347e"
import script from "./cModalProducts.vue?vue&type=script&lang=js"
export * from "./cModalProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports